// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qu-9";
export var arrowButtonContainer = "_qu-5";
export var arrowButtonIcon = "_qu-6";
export var carouselArrowButton = "_qu-2";
export var carouselElementContainer = "_qu-1";
export var currentSlide = "_qu-8";
export var left = "_qu-3";
export var otherSlide = "_qu-a";
export var productCarouselContainer = "_qu-0";
export var right = "_qu-4";
export var sliderOverflow = "_qu-7";